// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapFilterModal_dialog__ec7sl {
  max-width: 560px;
  background: none;
}

.mapFilterModal_dialog__ec7sl .mapFilterModal_MuiPaper-root__\\+Eku7 {
  backdrop-filter: blur(2px);
  border-radius: 8px;
}

.mapFilterModal_dialog-backdrop__pRjC2 {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
}

.mapFilterModal_dialog-content__H3Y5w {
  min-width: 360px;
  max-height: 700px;
}

.mapFilterModal_dialog-content__H3Y5w::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Webkit browsers */
}

.mapFilterModal_dialog-content__H3Y5w {
  -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
}
`, "",{"version":3,"sources":["webpack://./src/styles/mapFilterModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa,EAAE,uCAAuC;AACxD;;AAEA;EACE,wBAAwB,EAAE,yCAAyC;EACnE,qBAAqB,EAAE,+BAA+B;AACxD","sourcesContent":[".dialog {\n  max-width: 560px;\n  background: none;\n}\n\n.dialog .MuiPaper-root {\n  backdrop-filter: blur(2px);\n  border-radius: 8px;\n}\n\n.dialog-backdrop {\n  background: rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(1px);\n}\n\n.dialog-content {\n  min-width: 360px;\n  max-height: 700px;\n}\n\n.dialog-content::-webkit-scrollbar {\n  display: none; /* Hide scrollbar for Webkit browsers */\n}\n\n.dialog-content {\n  -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer */\n  scrollbar-width: none; /* Hide scrollbar for Firefox */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `mapFilterModal_dialog__ec7sl`,
	"MuiPaper-root": `mapFilterModal_MuiPaper-root__+Eku7`,
	"dialog-backdrop": `mapFilterModal_dialog-backdrop__pRjC2`,
	"dialog-content": `mapFilterModal_dialog-content__H3Y5w`
};
export default ___CSS_LOADER_EXPORT___;
